import styled from 'styled-components';

export const TextBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ theme }) => theme.breakpoints.minTablet} {
    max-width: ${({ isWide }) => (isWide ? '84.8rem' : '55.2rem')};
  }
`;
